import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/study-plan";
import { withAlternates } from "@/lib/route-i18n";

export const Route = createFileRoute("/ovningsplan")(
  withAlternates(routeOptions, "/ovningsplan"),
);
